import { Component, Input, ChangeDetectionStrategy } from '@angular/core';
import { ILabels } from "../../../../../libraries/interfaces/ILabels";
import { Yii } from "../../../../../libraries/interfaces/Yii";
import { IGetBookingsCommonResponse } from "../../../../../libraries/service/resources/booking/interfaces/IGetBookings";


@Component({
    selector: 'booking-vehicle-rental',
    template: `
    <booking-header [booking]="booking" [isVehicleRental]="true" [processingId]="processingId">
        <div class="creation e2e-select-booking col-1-bottom">
            {{labels.created}} {{booking.whenCreated | dateMoment: dateFormat.momentMedium}}
            <span *ngIf="booking.agent && (booking.agent.firstName || booking.agent.lastName)">
                {{labels.by}} {{booking.agent?.firstName}} {{booking.agent?.lastName}}
            </span>
        </div>
    </booking-header>
    `,
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BookingVehicleRentalComponent  {
    /**
     * in case we open the booking from a processing page, modify the url and breadcrumb
     */
    @Input()
    public processingId: number;

    @Input()
    public booking: IGetBookingsCommonResponse;

    public dateFormat = JSON.parse(sessionStorage.getItem('dateFormat'));

    public labels: ILabels = {
        created: Yii.t('wui-sasha-js', 'Créé le'),
        by: Yii.t('wui-sasha-js', 'par')
    };

}